import { render, staticRenderFns } from "./SchoolSignUp.vue?vue&type=template&id=0c01f78d&"
import script from "./SchoolSignUp.vue?vue&type=script&lang=js&"
export * from "./SchoolSignUp.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSignUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports